import React from 'react'
import {useIntl} from 'react-intl'

import {Button} from '@vio/atlas/Button'
import {Icon} from '@vio/atlas/Icon'

import {useIsMyListVisibilityOn} from '../../hooks/useIsMyListVisibilityOn'
import {
  MyListLinkComponent,
  useTrackMyListLinkClick
} from '../../hooks/useTrackMyListLinkClick'
import {myListMessages} from '../../myListMessages'

interface Props {
  href: string
  isAuthenticated: boolean
  component: MyListLinkComponent
  iconOnly?: boolean
  variant?: 'ghost' | 'ghostInverse'
  isEligible?: boolean
  className?: string
}

export const MyListHeaderLink = ({
  href,
  isAuthenticated,
  component,
  iconOnly = false,
  variant = 'ghost',
  isEligible = true,
  className
}: Props) => {
  const isOn = useIsMyListVisibilityOn(isEligible)
  const trackClick = useTrackMyListLinkClick({
    component,
    isAuthenticated,
    href
  })
  const {formatMessage} = useIntl()

  if (!isOn) return null

  const label = formatMessage(myListMessages.tabLabel)
  const size = iconOnly ? 'lg' : 'md'

  return (
    <Button
      className={className}
      variant={variant}
      size={size}
      href={href}
      dataId="MyListLink"
      ariaLabel={iconOnly ? label : undefined}
      iconStart={<Icon name="Heart" size={size} />}
      onClick={trackClick}
    >
      {!iconOnly && label}
    </Button>
  )
}
